import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import * as authActions from '../../../store/actions/authActions';

const SettingsSidebar = () => {
    const history = useHistory();

    const userProfile = useSelector(state => state.profile.userProfile);
    const dispatch = useDispatch();

    const logout = () => {
        dispatch(authActions.logout());
        history.push('/account')
    }

    const getAge = (userDob) => {
        var dob = new Date(userDob);
        var age = (new Date().getFullYear()) - dob.getFullYear();

        return age;
    }

    return (
        <Fragment>
            <div className="profile">
                <img className="profile-avatar" src={userProfile.profilePhotos.length === 0 ? 'https://t4america.org/wp-content/uploads/2016/10/Blank-User.jpg' : userProfile.profilePhotos[0].photoUrl} alt="Nothing" height="85px" width="85px" />
                <div className="profile-info">
                    <h2 className="profile-name">{userProfile.profileName}</h2>
                    <p className="profile-age">Age: {getAge(userProfile.dateOfBirth)}</p>
                </div>                
            </div>

            <nav className="chat-nav">
                <div className="chat-nav-item">
                    <Link to="/">
                        <i className="fa fa-home" />
                        Home
                    </Link>
                </div>
                <div className="chat-nav-item">
                    <Link to="/settings">
                        <i className="fa fa-cog"></i> 
                        General Settings
                    </Link>
                </div>
                <div className="chat-nav-item">
                    <Link to="/profile/edit">
                        <i className="fa fa-pencil"></i>
                        Edit Profile
                    </Link>
                </div>
                <div className="chat-nav-item">
                    <Link to="/settings/preferences">
                        <i className="fa fa-sliders"></i> 
                        Preferences
                    </Link>
                </div>
            </nav>

            <div className="admin-controls">

                <div className="admin-control-item">
                    <button onClick={logout}>logout</button>
                </div>

            </div>
        </Fragment>
    );
};

export default SettingsSidebar;